/**
 * Post-instalación PWA: el link en la misma pestaña no abre la app instalada;
 * sí funciona volver al portal o abrir desde el ícono (resume URL).
 */
import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'
import { UDV_SURFACE, udvDialogProps } from './udvSurface'
import {
  getPwaInstallSuccessBody,
  getPwaInstallSuccessIconHint,
} from '../utils/pwaInstallPrompt'

/**
 * @param {{
 *   open: boolean,
 *   onClose: () => void,
 *   studyUrl?: string,
 *   portalUrl?: string|null,
 *   onReturnToPortal?: (() => void)|null,
 *   onCopyStudyLink?: (() => void)|null,
 * }} props
 */
function InstallPwaSuccessDlg({
  open,
  onClose,
  studyUrl = '',
  portalUrl = null,
  onReturnToPortal = null,
  onCopyStudyLink = null,
}) {
  const { t } = useTranslation()
  const hasPortal = !!(portalUrl && String(portalUrl).trim())

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs" {...udvDialogProps}>
      <DialogTitle style={UDV_SURFACE.title}>
        {t('pwa.installSuccessTitle')}
      </DialogTitle>
      <DialogContent style={UDV_SURFACE.content}>
        <Typography variant="body2" paragraph style={{ color: 'inherit' }}>
          {getPwaInstallSuccessBody(t)}
        </Typography>
        {hasPortal ? (
          <Typography variant="body2" paragraph style={{ color: 'inherit' }}>
            <strong>{t('pwa.installSuccessPortalHint')}</strong>
          </Typography>
        ) : (
          <Typography variant="body2" paragraph style={{ color: 'inherit' }}>
            <strong>{getPwaInstallSuccessIconHint(t)}</strong>
          </Typography>
        )}
        {studyUrl ? (
          <Typography variant="caption" style={UDV_SURFACE.muted}>
            {t('pwa.installSuccessSaved')}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions style={{ ...UDV_SURFACE.actions, flexWrap: 'wrap', gap: 8 }}>
        {hasPortal ? (
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReturnToPortal && onReturnToPortal()}
            style={UDV_SURFACE.btnPrimary}
          >
            {t('pwa.installSuccessPortalCta')}
          </Button>
        ) : null}
        <Button onClick={onClose} style={UDV_SURFACE.btnGhost}>
          {t('pwa.installSuccessIconCta')}
        </Button>
        {studyUrl && typeof onCopyStudyLink === 'function' ? (
          <Button onClick={onCopyStudyLink} style={UDV_SURFACE.btnGhost}>
            {t('pwa.installSuccessCopyLink')}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  )
}

export default InstallPwaSuccessDlg
